import { useEffect, useState } from 'react';

import TableApi from '../../api/TableApi';

// Capacités de filtrage d'une table source : `withFilter` est vrai dès qu'elle expose au moins une
// capacité de filtrage. Source unique de vérité partagée par l'onglet "Filters" (FiltersSelection)
// et par la colonne FILTER des grilles de mapping, pour que les deux s'affichent selon le même calcul.
// tableReferenceId <= 0 (pas de table, ou source = un autre path sans TableReferenceId) => pas de filtre.
export function useFilteringCapabilities(tableReferenceId: number): { withFilter: boolean; capabilitiesLoaded: boolean } {

    const [withFilter, setWithFilter] = useState(false);
    const [capabilitiesLoaded, setCapabilitiesLoaded] = useState(false);

    useEffect(() => {
        if (tableReferenceId <= 0) {
            setWithFilter(false);
            setCapabilitiesLoaded(true);
            return;
        }

        let cancelled = false;
        setCapabilitiesLoaded(false);
        TableApi.GetFilteringCapabilitiesAsync(tableReferenceId).then(getFilteringCapabilitiesResult => {
            if (cancelled) {
                return;
            }
            setWithFilter(!getFilteringCapabilitiesResult.IsFailed() && getFilteringCapabilitiesResult.Result.FilteringCapabilities.length > 0);
            setCapabilitiesLoaded(true);
        });

        return () => { cancelled = true; };
    }, [tableReferenceId]);

    return { withFilter, capabilitiesLoaded };
}

export default useFilteringCapabilities;
